<template>
  <v-app>
    <template v-if="getLogged">
      <Admin></Admin>
    </template>
    <template v-else>
      <Default></Default>
    </template>
  </v-app>
</template>

<script>

import {mapGetters} from 'vuex';
import Admin from "@/layouts/Admin";
import Default from "@/layouts/Default";

export default {
  name: 'App',
  components: {Default, Admin},
  data: () => ({
    //
  }),
  computed: {
    ...mapGetters({
      'getLogged': 'user/getLogged'
    }),
  },
};
</script>
